import React, { PureComponent } from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import includes from 'lodash/includes';
import { ToolSetOptions, ToolSetOptionsItem } from '../../../../../components/ToolSet';
import Link from '../../../../../components/SEO/Link';
import { toHTMLId } from '../../../../../utils/commonHelper';
import messages from '../../../../../utils/translationMessages';
import * as urlHelpers from '../../../../../utils/urlHelpers/boats';
import { getBoatsConstants } from '../../../../../constants/boats/index';
import { PortalConfigContext } from '../../../../../config/portal';

class FilterFuelType extends PureComponent {
  state = {
    selectedFuelTypes: this.props.selectedFuelTypes ? this.props.selectedFuelTypes : []
  }

  updateMultiInput() {
    if (this.props.selectedFuelTypes !== undefined) {
      this.setState({ selectedFuelTypes: this.props.selectedFuelTypes });
    }
  }

  updateFuelTypeList(fuelType) {
    const { selectedFuelTypes } = this.state;
    let newFuelTypes;
    if (includes(selectedFuelTypes, fuelType)) {
      newFuelTypes = selectedFuelTypes.filter((fuel) => { return fuel !== fuelType; });
    } else {
      newFuelTypes = [...selectedFuelTypes, fuelType];
    }
    return newFuelTypes;
  }

  handleToggleFuelType(fuelType) {
    const { selectedFuelTypes } = this.state;
    const selectedFuelTypesSizeBeforeUpdate = selectedFuelTypes.length;
    const newFuelTypes = this.updateFuelTypeList(fuelType);
    this.setState({ selectedFuelTypes: newFuelTypes });
    if (this.props.tracking) {
      if (selectedFuelTypesSizeBeforeUpdate > newFuelTypes.length) {
        this.props.tracking.facetRemoved(`fuel type removed - ${fuelType}`);
      } else {
        this.props.tracking.facetAdded({ fuelType: [fuelType] });
      }
    }
    this.props.handleDataChange('fuelType', newFuelTypes);
  }

  componentDidMount() {
    this.updateMultiInput();
  }

  componentDidUpdate() {
    this.updateMultiInput();
  }

  renderFuelFilter = (urlId, value, translatedName) => {
    const { params } = this.props;
    const { selectedFuelTypes } = this.state;
    const nameId = toHTMLId(urlId);

    const mappedUrlId = getBoatsConstants().FUEL_TYPE_MAPPING.urlId[urlId] ?
      getBoatsConstants().FUEL_TYPE_MAPPING.urlId[urlId] : urlId;

    return (
      <ToolSetOptionsItem
        type="checkbox"
        key={`fuel-${nameId}`}
        id={`fuel-${nameId}`}
        name={`fuel-${nameId}`}
        value={value}
        selected={includes(selectedFuelTypes, mappedUrlId)}
        onClick={val => this.handleToggleFuelType(val)}
      >
        <Link
          className={`class-${nameId}-link`}
          href={urlHelpers.generateSearchPath(
            { fuelType: this.updateFuelTypeList(value) },
            params,
            true,
          )}
          onClick={(e) => e.preventDefault()}
        >
          {translatedName}
        </Link>
      </ToolSetOptionsItem>
    );
  }

  render() {
    const { fuelTypes, intl: { formatMessage: t } } = this.props;

    const fuelFilters = fuelTypes.filter((facet) => {
      return facet.count;
    }).sort((facetA, facetB) => {
      const fuelNameA = t(messages.fuelTypeFacetText[facetA.value]);
      const fuelNameB = t(messages.fuelTypeFacetText[facetB.value]);
      return fuelNameA > fuelNameB ? 1 : -1;
    }).map((facet) => {
      const fuelName = t(messages.fuelTypeFacetText[facet.value]);
      let unslugifiedFacet = urlHelpers.unslugify(get(facet, 'urlId', facet.value), '+', '-');
      unslugifiedFacet = urlHelpers.unslugify(unslugifiedFacet, '--', '-');
      return this.renderFuelFilter(unslugifiedFacet, facet.value, fuelName);
    });

    return (
      <div className="search-filter fuel-type">
        { fuelTypes.length ? (
          <ToolSetOptions>
            { fuelFilters }
          </ToolSetOptions>
        ) : null }
      </div>
    );
  }
}

FilterFuelType.contextType = PortalConfigContext;

FilterFuelType.propTypes = {
  handleDataChange: PropTypes.func.isRequired,
  fuelTypes: PropTypes.arrayOf(PropTypes.shape({
    count: PropTypes.number,
    urlId: PropTypes.string,
    value: PropTypes.string
  })),
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  params: PropTypes.shape({
    fuelType: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.string
    ])
  }),
  selectedFuelTypes: PropTypes.arrayOf(PropTypes.string),
  tracking: PropTypes.shape({
    facetAdded: PropTypes.func.isRequired,
    facetRemoved: PropTypes.func.isRequired,
  }),
};

export default injectIntl(FilterFuelType);
